import { NavLink } from "react-router-dom";
import "./NavMain.scss";
import Logo from "../SVG/LogoSvg";

const NavMain = () => {
  return (
    <header>
      <nav className="navMain">
        <NavLink className="logo" to={".."}>
          <Logo />
        </NavLink>

        <ul className="list">
          <li>
            <NavLink to={"training"}>Trainingen</NavLink>
          </li>
          <li>
            <NavLink to={"coaching"}>1-op-1 coaching</NavLink>
          </li>
          <li>
            <NavLink to={"writing"}>Boeken</NavLink>
          </li>
          <li>
            <NavLink to={"seminars"}>Lezingen</NavLink>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default NavMain;
